// Suggests one existing stop from the student's stored confirmations only (never grades or
// assumed preferences). Advisory: every route stays open; nothing is redirected or completed.
const joinLabels = (labels) =>
  labels.length < 2 ? labels.join("") : `${labels.slice(0, -1).join(", ")} and ${labels[labels.length - 1]}`;

export function suggestNextStep(allStations, pillarsCompleted) {
  const stations = allStations;
  const done = new Set(pillarsCompleted || []);
  const confirmed = stations.filter((s) => done.has(s.progress));
  if (confirmed.length === stations.length) return { allDone: true };
  const next = stations.find((s) => !done.has(s.progress));
  const reason = confirmed.length
    ? `You've confirmed ${joinLabels(confirmed.map((s) => s.label))}. ${next.label} is the first stop you haven't confirmed yet, but you can start anywhere.`
    : `Nothing on your journey is confirmed yet, so ${next.label} is the first stop on the map. Start anywhere else if it suits you better.`;
  return { key: next.key, reason };
}
